export default "__VITE_ASSET__vUVvLhdqHBZZqG5mYUfMLQ__"